// src/das-application/application-steps/StepContent3.js
import React, { memo } from "react";

import Grid from "@mui/material/Grid";

import FormRow from "../../helpers/FormRow";
import FormInput from "../../helpers/FormInput";

function StepContent3({
  formData,
  setFormData,
  stepErrors,
  handleChange,
  isReadOnly,
}) {
  // console.log("data", data);

  return (
    <div className="form-group">
      <h3 className="bold-text">Evidence Of Achievement:</h3>
      <p>
        This application requires that you provide evidence of outstanding
        achievement in your chosen area of interest. Please type below, or
        attach a one-page statement, that describes your achievements. Depending
        on your chosen area of interest, you will also be required to provide or
        participate in one or more of the following: portfolio, project,
        research paper, performance, presentation, demonstration, or interview.
        Your school counsellor will provide you with more details.
      </p>
      <FormRow spacing={2}>
        <Grid item xs={12}>
          <FormInput
            label="Evidence Of Achievement"
            id="achievements"
            value={formData.achievements}
            onChange={handleChange("achievements")}
            multiline
            rows={6}
            required
            disabled={isReadOnly}
            error={Boolean(stepErrors.achievements)}
            helperText={stepErrors.achievements || ""}
          />
        </Grid>
      </FormRow>
    </div>
  );
}

export default memo(StepContent3);
